import { FandomPage } from "@/components/FandomPage";
import { MD, MD_PAIRS } from "@/components/mdzsData";
import { MD_CHARM } from "@/components/charms";

const F = {
  id: "mdzs", prefix: "md", name: "The Master of Diabolism",
  heading: ["Lotus, flutes", "and beads."],
  intro: "Join the night hunt, find your match, then wear their colors. Every character's bracelet can be made by hand just for you.",
  quizLabel: "Night hunt · personality", quizLines: ["Which cultivator", "are you?"],
  quizIntro: "Answer seven questions to find your Master of Diabolism match.",
  quiz: MD, pairs: MD_PAIRS, charm: MD_CHARM, cover: "/img/mdzs-cover.jpg",
  bgColor: "#04090d",
  bgImage: "radial-gradient(60% 50% at 85% 10%, rgba(103,232,249,0.16), transparent 70%), radial-gradient(45% 40% at 10% 85%, rgba(193,18,31,0.2), transparent 70%)",
  accent: {
    text: "text-cyan-200", soft: "text-cyan-100", border: "border-cyan-200/25", bar: "bg-cyan-400",
    hover: "hover:border-cyan-200 hover:bg-cyan-900/30", glow: "rgba(103,232,249,0.16)",
    panel: "bg-[#071820]/85", answer: "border-cyan-200/25 bg-[#04090d]/60",
    card: "border-cyan-200/20 bg-[#071820]/85 hover:border-cyan-200/50",
  },
};

export default function MdzsPage() {
  return <FandomPage f={F} />;
}
